/**
 * Typeguard for identifying a value that is not null or undefined.
 * @param value Value to check
 */
export function isNotNullOrUndefined(value) {
  return value != null;
}
export default isNotNullOrUndefined;
//# sourceMappingURL=isNotNullOrUndefined.js.map